module.exports = __webpack_public_path__ + "static/media/underReviewGreenIcon.2b086752.svg";